/**
 * Wspólne Tailwind classes dla native HTML inputów (input/select/textarea).
 * Wyekstrahowane z {@code FieldRenderer.tsx} bez zmian w wyglądzie.
 */
export function inputCommon(disabled?: boolean): string {
  return [
    'block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900',
    'placeholder:text-slate-400 shadow-xs transition-colors',
    'focus:outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-500/15',
    'hover:border-slate-400',
    disabled ? 'cursor-not-allowed bg-slate-50 text-slate-500 opacity-90 hover:border-slate-300' : '',
  ].join(' ')
}
